// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"6e6f1c9a","247":"00f2d1fa","284":"8682b741","440":"4a6f0409","627":"4db2eb91","834":"366c5de7","867":"18bfbfb4","903":"bfef7749","923":"bf617e0c","938":"61ed0da9"}[chunkId] + ".chunk.js";
};